import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useTealiumEventProperties, useTrackPageView } from '@grandvisionhq/svc-tealium/events';
import { useAlgoliaData } from '../../../Algolia/hooks/use-algolia-data.js';
import { useFacets } from '../../../hooks/use-facets.js';
import { mapFacetsToTealiumFacetValue } from '../../mappers/map-facets-to-tealium-facet-value.js';

const TealiumSearchPageView = ()=>{
    const { commonEventProperties , getCommonUserProperties  } = useTealiumEventProperties();
    const { total , searchQuery  } = useAlgoliaData();
    const { appliedFacets  } = useFacets();
    const facets = mapFacetsToTealiumFacetValue(appliedFacets);
    const searchPageView = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const commonUserProperties = yield getCommonUserProperties();
        if (!commonUserProperties) return;
        return swcHelpers.objectSpread({}, commonEventProperties, commonUserProperties, {
            id: 'VirtualPage-View',
            Page_Type: 'Search',
            Page_Section1: 'Search',
            Page_Design: 'Tiles&Pages',
            Events_SearchFiltering: '1',
            Search_ResultItemsQnt: `${total}`,
            Search_FacetValues_String: facets,
            Search_Keyword: searchQuery,
            Search_Type: 'suggested',
            Search_View: 'SERP'
        });
    }), // Only need to trigger this page view on initial render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getCommonUserProperties
    ]);
    useTrackPageView(searchPageView);
    return null;
};

export { TealiumSearchPageView };
//# sourceMappingURL=TealiumSearchPageView.js.map
